import React from 'react'

export const Banner = () => {
  return (
      
   <section className="banner-section align-items-center">
        <div className="container">
        <div className="banner-top">
            <div className="banner-content">
            
<h2>

    Centraliser et garantir la traçabilité des archives dans un espace unique. 

</h2>
            <p>

        Une solution Ged/Archivage pensée pour sécuriser, 
        organiser et valoriser les documents de vos entités internes.

            </p>
            
            </div>
        </div>
        </div>
    </section>

  )
}
